import { ReactChild, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { IconCamera } from 'components/atoms/icons/IconCamera';
// import { IconPhoto } from 'components/atoms/icons/IconPhoto';
import { useTranslation } from 'react-i18next';
import { CameraModal } from './CameraModal';
// import { typeImages, MAX_IMAGE_FILE_SIZE } from 'util/ConstantValues';
// import { validateFiles } from 'util/validator';

interface ImageUploadButtonsProps {
  onImageSelect: (
    files: File[],
    needToConfirm?: boolean,
    onRetake?: () => void
  ) => void;
  disabled?: boolean;
  imagePreviewList?: ReactChild;
  maxFilesLength: number;
  currentImagesLength: number;
}

export const ImageUploadButtons = ({
  onImageSelect,
  disabled = false,
  imagePreviewList,
  // maxFilesLength,
  currentImagesLength,
}: ImageUploadButtonsProps) => {
  const { t } = useTranslation();

  const [isCameraOpen, setIsCameraOpen] = useState(false);
  // const galleryInputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState('');

  const handleCameraClick = () => {
    if (!disabled) {
      setIsCameraOpen(true);
    }
  };

  // const handleGalleryClick = () => {
  //   galleryInputRef.current?.click();
  // };

  // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const files = event.target.files;
  //   if (files && files.length > 0) {
  //     const msgError = validateFiles({
  //       files,
  //       maxSize: MAX_IMAGE_FILE_SIZE,
  //       fileTypes: typeImages,
  //       errorMessages: {
  //         wrongType: t('messages.M_017'),
  //         sizeExceeded: t('messages.M_018', {
  //           value: `${MAX_IMAGE_FILE_SIZE}MB`,
  //         }),
  //       },
  //     });

  //     if (msgError) {
  //       setError(msgError);
  //       event.target.value = '';
  //       return;
  //     }

  //     if (files.length > maxFilesLength - currentImagesLength) {
  //       event.target.value = '';
  //       setError(t('messages.M_055', { max: maxFilesLength }) || '');
  //       return;
  //     }

  //     setError('');
  //     onImageSelect(Array.from(files));

  //     event.target.value = '';
  //   }
  // };

  const handleCameraCapture = (file: File) => {
    setIsCameraOpen(false);
    onImageSelect([file], true, () => setIsCameraOpen(true));
  };

  useEffect(() => {
    if (error) {
      setError('');
    }
  }, [currentImagesLength]);

  return (
    <>
      <div className={styles.imageUploadButtons}>
        <div className={styles.buttonWrapper} onClick={handleCameraClick}>
          <button
            type="button"
            className={styles.uploadButton}
            disabled={disabled}
          >
            <IconCamera />
          </button>
          <span>{t('common.button.take_photo')}</span>
        </div>

        {/* TODO: hidden gallery button for current release version */}
        {/* <div className={styles.buttonWrapper} onClick={handleGalleryClick}>
          <button
            type="button"
            className={styles.uploadButton}
            disabled={disabled}
          >
            <IconPhoto color="#86ea5c" />
          </button>
          <span>{t('common.button.choose_from_library')}</span>
          <input
            ref={galleryInputRef}
            type="file"
            accept=".jpg, .jpeg, .png, .heic"
            multiple
            style={{ display: 'none' }}
            onChange={handleFileChange}
            disabled={disabled}
          />
        </div> */}
      </div>
      {error && <p className={styles.errorMessage}>{error}</p>}

      {isCameraOpen && (
        <CameraModal
          disabled={disabled}
          onClose={() => setIsCameraOpen(false)}
          onCapture={handleCameraCapture}
          imagePreviewList={imagePreviewList}
        />
      )}
    </>
  );
};
